import { createApp } from 'vue'
import { Icon,Toast } from 'vant'
import App from './App.vue'
import router from './router'
import store from './store'
import Valid from './utils/valid'
import {Button,Checkbox,Carousel,Card,Row,Col,message,Input,List} from 'ant-design-vue'
import * as antIcons from '@ant-design/icons-vue'

import 'vant/lib/index.css'
import 'ant-design-vue/dist/antd.css'

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'


const app = createApp(App)
app.config.globalProperties.$message = message
app.provide('$Valid', Valid)
app.use(Toast)
app.use(Icon)
app.use(Button).use(Checkbox).use(Carousel).use(Card).use(Row).use(Col).use(Input).use(List)
app.use(router).use(store).mount('#app')

//全部导入ant-design/icons-vue 所有图标
Object.keys(antIcons).forEach(key => {
    app.component(key,antIcons[key])
})
app.config.globalProperties.$antIcons = antIcons
